<template>
  <div class="filter-button-wrapper">
    <b-button
      v-for="option in options"
      :key="option.key"
      v-model="computedOptions"
      :disabled="disabled"
      class="me-2"
      :class="computedOptions === option.value ? 'active' : ''"
      pill
      @click="onChangeOptions(option.value)"
    >
      {{ option.label }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  computed: {
    computedOptions: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    onChangeOptions(val) {
      this.computedOptions = val
    },
  },
}
</script>
<style lang="scss" scoped>
.filter-button-wrapper {
  display: flex;
}

.btn-secondary.active {
  background-color: $mep-secondary-100;
  color: $mep-secondary;
  border: 1px solid $mep-secondary;
}
</style>
